import { Dialog, DialogContent } from '@proerp/ui';
import { shortcutsByGroup } from '@/lib/shortcuts';

/** Eine einzelne Taste in kbd-Optik (konsistent mit dem Palette-Fuß). */
function Key({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="inline-flex min-w-[1.6rem] items-center justify-center rounded border border-border bg-muted px-1.5 py-0.5 font-sans text-xs text-muted-foreground">
      {children}
    </kbd>
  );
}

/**
 * Spickzettel aller globalen Tastenkürzel — geöffnet mit „?" (siehe App-Shell)
 * oder über die Palette. Inhalt kommt aus dem zentralen Register (`shortcuts.ts`),
 * damit es nur eine Quelle gibt.
 */
export function ShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const sections = shortcutsByGroup();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent title="Tastenkürzel" description="Schneller arbeiten mit der Tastatur.">
        <div className="flex flex-col gap-5">
          {sections.map((section) => (
            <div key={section.group} className="flex flex-col gap-1.5">
              <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                {section.group}
              </h3>
              <ul className="flex flex-col">
                {section.items.map((shortcut) => (
                  <li
                    key={shortcut.label}
                    className="flex items-center justify-between gap-4 border-b border-border/60 py-2 text-sm last:border-b-0"
                  >
                    <span className="text-foreground">{shortcut.label}</span>
                    <span className="flex shrink-0 items-center gap-1">
                      {shortcut.keys.map((key, index) => (
                        <Key key={`${shortcut.label}-${index}`}>{key}</Key>
                      ))}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
